import { useAppStore } from "../../../store/store";

const usePaxSession = () => {
  const paxSessions = useAppStore((state) => state.paxSessions);

  const path = window.location.pathname;

  const regex = /\/pax\/([^/]+)/;
  const match = path.match(regex);

  if (match && match[1]) {
    const paxSession = paxSessions.find((p) => p.paxSessionId === match[1]);

    return paxSession;
  } else {
    return;
  }
};

export default usePaxSession;
